var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('i',{staticClass:"mdi mdi-arrow-left mdi-24px mr-3 cursor-pointer",on:{"click":_vm.handleClick}}),_c('h3',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }